import { environment } from 'src/environments/environment';
export class API{
    public static prodBaseURL = environment.apiUrl;
}
